import src from "IMAGE";
export default { src, width: 1032, height: 209, blurWidth: 0, blurHeight: 0};
